module.exports = __webpack_public_path__ + "static/media/intro.9ed62f53.png";